<!--
cell包裹器

1.默认slot
2.props.ph - {Boolean} paddingX
2.props.mb - {Boolean} marginBottom
3.props.rd - {Boolean} borderRadius
-->

<template>
  <div class="cell-wrapper">
    <h3
      class="hd"
      :class="{ ph: ph }"
      style="margin-bottom: -0.16rem"
      v-if="title"
    >
      {{ title }}{{ subtitle }}
    </h3>
    <div class="bd" :class="cls">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {},
  data() {
    return {}
  },
  methods: {},
  props: {
    ph: {
      type: Boolean,
      default: false
    },
    mt: {
      type: Boolean,
      default: false
    },
    mb: {
      type: Boolean,
      default: false
    },
    rd: {
      type: Boolean,
      default: false
    },
    bg: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    cls() {
      return {
        ph: this.ph,
        mt: this.mt,
        mb: this.mb,
        rd: this.rd,
        bg: this.bg
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.cell-wrapper {
  .hd {
    height: rem(88px);
    background-color: #fff;
    border-radius: rem(16px);
    line-height: rem(88px);
    font-size: rem(30px);
    color: #262626;
    font-weight: 500;
    &.ph {
      padding: 0 rem(24px);
    }
  }
  .bd {
    &.ph {
      padding-left: rem(24px);
    }
    &.mt {
      margin-top: rem(20px);
    }
    &.mb {
      margin-bottom: rem(20px);
    }
    &.rd {
      border-radius: rem(6px);
      overflow: hidden;
    }
    &.bg {
      background-color: #fff;
      border-radius: rem(16px);
      margin-bottom: rem(20px);
    }
  }
}
</style>
